<div class="filter-dropdown">
	<button class="filter-selector" [matMenuTriggerFor]="filterMenu" #menuTrigger="matMenuTrigger">
		<div style="display: flex; align-items: center; gap: 8px">
			<div class="filterSelected" *ngIf="filterState.count() !== 0">
				{{ filterState.count() }}
			</div>
			<span>Filtros</span>
		</div>
		<mat-icon svgIcon="porto-bank-icons:down-arrow" style="width: 20px; height: 20px" />
	</button>
</div>

<mat-menu #filterMenu="matMenu" class="filter-menu-panel" xPosition="after" [hasBackdrop]="true">
	<div class="menu-content" (click)="$event.stopPropagation()">
		@if ((statusCuisines$ | async) === 'pending') {
			<ui-pm-loading-page />
		} @else {
			<div class="dialog-container">
				<p class="subtitle">Tipo de culinária</p>
				<div class="buttons-group">
					<button
						mat-stroked-button
						*ngFor="let cuisine of cuisines$ | async"
						(click)="filterState.setCuisine(cuisine)"
						[class.selected]="filterState.includesCuisine(cuisine)"
					>
						{{ cuisine.name }}
					</button>
				</div>

				<p class="subtitle">Benefícios</p>
				<div class="buttons-group">
					<button
						mat-stroked-button
						*ngFor="let benefit of filterState.benefitIds"
						(click)="filterState.setBenefit(benefit)"
						[class.selected]="filterState.includesBenefit(benefit)"
					>
						{{ benefit.display }}
					</button>
				</div>
			</div>

			<div class="footer-actions">
				<button mat-button (click)="cleanFilter(); menuTrigger.closeMenu()" class="button-outline">
					Limpar filtros
				</button>
				<button mat-button (click)="applyFilter(); menuTrigger.closeMenu()" class="button-raised">
					Filtrar
				</button>
			</div>
		}
	</div>
</mat-menu>
